import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getJobLevelListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const params = { lookupHdrId: "JOB_LEVEL", sort: "seq,asc" };
		const res = await api.get.general.list(params);
		const content = res.map(({ lookupTitle, ...o }) => ({ label: lookupTitle, value: lookupTitle, ...o }));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getJobLevelListing;
